import { render } from "./BuzzEmployeeMentionDialog.vue?vue&type=template&id=65794763&scoped=true"
import script from "./BuzzEmployeeMentionDialog.vue?vue&type=script&lang=js"
export * from "./BuzzEmployeeMentionDialog.vue?vue&type=script&lang=js"

import "./buzz-employee-mention-dialog.scss?vue&type=style&index=0&id=65794763&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65794763"]])

export default __exports__